import { useMemo } from 'react';
import { type PieChartItem } from '@/utils/draw-pie-chart';

const useTotal = (items: PieChartItem[]): number =>
  useMemo(() => items.reduce((sum, item) => sum + item.value, 0), [items]);

export default useTotal;
